import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import skuUtils from 'utils/Sku';

class OOSAlternateLinkBindings {
    /**
     * Track when user clicks "Select alternate" for an out of stock sample/reward
     * AC 1: Fire Adobe Analytics call with appropriate s.pagename based on item type
     * @param {object} item - The basket item
     */
    static trackSelectAlternateClick = item => {
        if (!item || !item.sku) {
            return;
        }

        const isSample = skuUtils.isSample(item.sku);
        const isBiReward = skuUtils.isBiReward(item.sku);

        let pageName;
        let pageDetail = '';

        // Determine the correct pageName based on item type
        if (isSample) {
            pageDetail = anaConsts.PAGE_DETAIL.SAMPLES;
            pageName = `basket:${anaConsts.PAGE_DETAIL.SAMPLES}:n/a:*${anaConsts.ACTION_INFO.SELECT_ALTERNATE}`;
        } else if (isBiReward) {
            pageDetail = anaConsts.PAGE_DETAIL.BI_REWARDS;
            pageName = `basket:${anaConsts.PAGE_DETAIL.REWARDS_BAZAAR}:n/a:*${anaConsts.ACTION_INFO.SELECT_ALTERNATE}`;
        }

        // Only fire analytics if we have a valid pageName
        if (pageName) {
            processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
                data: {
                    pageName,
                    pageDetail,
                    actionInfo: anaConsts.ACTION_INFO.SELECT_ALTERNATE,
                    linkName: pageName,
                    internalCampaign: pageName
                }
            });
        }
    };

    static tracErrorMessageAnallytics = details => {
        const { fieldName, errorMessage } = details;

        let pageDetail, pageName;

        // Determine pageDetail and pageName based on the fieldName parameter
        if (fieldName === 'smart sample') {
            pageDetail = anaConsts.PAGE_DETAIL.SAMPLES;
            pageName = `basket:${anaConsts.PAGE_DETAIL.SAMPLES}:n/a:*${anaConsts.ACTION_INFO.SELECT_ALTERNATE}`;
        } else if (fieldName === 'bi-reward') {
            pageDetail = anaConsts.PAGE_DETAIL.REWARDS_BAZAAR;
            pageName = `basket:${anaConsts.PAGE_DETAIL.REWARDS_BAZAAR}:n/a:*${anaConsts.ACTION_INFO.SELECT_ALTERNATE}`;
        }

        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: {
                pageName,
                pageDetail,
                fieldErrors: `sample oos: ${fieldName}`,
                errorMessages: errorMessage
            }
        });
    };

    static trackProductSamplesModalOpen = item => {
        const isSample = skuUtils.isSample(item);
        const isBiReward = skuUtils.isBiReward(item);

        let pageDetail, pageName;

        if (isSample) {
            pageDetail = anaConsts.PAGE_DETAIL.SAMPLES;
            pageName = `basket:${anaConsts.PAGE_DETAIL.SAMPLES}:n/a:*${anaConsts.ACTION_INFO.SELECT_ALTERNATE}`;
        }

        if (isBiReward) {
            pageDetail = anaConsts.PAGE_DETAIL.BI_REWARDS;
            pageName = `basket:${anaConsts.PAGE_DETAIL.REWARDS_BAZAAR}:n/a:*${anaConsts.ACTION_INFO.SELECT_ALTERNATE}`;
        }

        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: {
                pageName,
                pageDetail,
                linkName: pageName,
                internalCampaign: pageName
            }
        });
    };

    /**
     * Track when the Product Samples Modal is closed
     * @param {object} data - Analytics data
     * @param {string} data.productId - The main product ID
     * @param {number} data.samplesSelected - Number of samples selected
     * @param {boolean} data.hasOutOfStockAttempt - Whether user tried to select OOS samples
     */
    static trackProductSamplesModalClose = (data = {}) => {
        const { productId, samplesSelected, hasOutOfStockAttempt } = data;
        const pageType = anaConsts.PAGE_TYPES.PRODUCT;
        const pageDetail = 'product samples modal';
        const actionText = hasOutOfStockAttempt
            ? `close:${productId}:selected:${samplesSelected}:oos-attempt`
            : `close:${productId}:selected:${samplesSelected}`;
        const link = `${pageType}:${pageDetail}:${actionText}`;

        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: {
                pageName: `${pageType}:${pageDetail}:${productId}:*`,
                pageType,
                pageDetail,
                linkName: link,
                internalCampaign: link
            }
        });
    };
}

export default OOSAlternateLinkBindings;
